import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SharedCheckout } from "../../components/checkout/shared-checkout";
import { useFlowPath } from "../../hooks/use-flow-path";
import { useCartState } from "../../store/use-cart-state";
import { configName } from "../config/config-name";
import { routes } from "../config/routes";

export const Checkout = () => {
  const history = useHistory();
  const flowPath = useFlowPath();
  const { t } = useTranslation();
  const { products, getTotalPrice } = useCartState();

  useEffect(() => {
    if (products.length === 0) {
      history.push(flowPath(routes.catalog.raw()));
    }
  }, [products, history, flowPath]);

  const handleBack = () => {
    history.push(flowPath(routes.catalog.raw()));
  };

  return (
    <SharedCheckout
      configName={configName}
      title={t("cmsTranslations.purchase_products.user_data_form.title")}
      description={t("cmsTranslations.purchase_products.user_data_form.description")}
      onBack={handleBack}
      thankYouRoute={routes.thankYou}
      products={products}
      totalPrice={getTotalPrice()}
    />
  );
};
